import React from 'react';

class ChunkReloadBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    if (/Loading chunk .* failed/.test(error.message)) {
      return { hasError: true };
    }
    return null;
  }

  componentDidMount() {
    window.addEventListener('unhandledrejection', this.handleRejection);
    window.addEventListener('error', this.handleError);
  }

  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.handleRejection);
    window.removeEventListener('error', this.handleError);
  }

  handleRejection = (event) => {
    const msg = event.reason?.message || event.reason;
    if (typeof msg === 'string' && /Loading chunk .* failed/.test(msg)) {
      this.setState({ hasError: true });
    }
  };

  handleError = (event) => {
    if (/Loading chunk .* failed/.test(event.message)) {
      this.setState({ hasError: true });
    }
  };

  componentDidUpdate(_, prevState) {
    if (!prevState.hasError && this.state.hasError) {
      setTimeout(() => window.location.reload(), 1000);
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Nova versão disponível. Atualizando em breve…</div>;
    }
    return this.props.children;
  }
}

export default ChunkReloadBoundary;
